import styled from 'styled-components';
import Section from '../Section';

const StyledSection = styled(Section)`
  position: relative;
`;

export default StyledSection;
